import { memo } from "react";
function SpottedTrailerMarker({
  backgroundColor = "#E5A70D",
  borderColor = "white",
}) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="25"
        height="25"
        rx="2.5"
        fill={backgroundColor}
      />
      <g clip-path="url(#clip0_2159_12417)">
        <path
          d="M17.3327 15.0003V10.3337V7.66699H7.99935C7.26602 7.66699 6.66602 8.26699 6.66602 9.00033V16.3337H7.99935C7.99935 17.4403 8.89268 18.3337 9.99935 18.3337C11.106 18.3337 11.9993 17.4403 11.9993 16.3337H15.9993C15.9993 16.3337 16.8927 16.3337 17.9994 16.3337H19.3327V15.0003H17.3327ZM9.99935 17.0003C9.63268 17.0003 9.33268 16.7003 9.33268 16.3337C9.33268 15.967 9.63268 15.667 9.99935 15.667C10.366 15.667 10.666 15.967 10.666 16.3337C10.666 16.7003 10.366 17.0003 9.99935 17.0003ZM11.4793 15.0003C11.1127 14.5937 10.5927 14.3337 9.99935 14.3337C9.40602 14.3337 8.88602 14.5937 8.51935 15.0003H7.99935V9.00033H15.9993V15.0003H11.4793Z"
          fill={borderColor}
        />
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="25"
        height="25"
        rx="2.5"
        stroke={borderColor}
      />
      <defs>
        <clipPath id="clip0_2159_12417">
          <rect
            width="16"
            height="16"
            fill={borderColor}
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(SpottedTrailerMarker);
